import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import YourProperties from './yourProperties/YourProperties';
import Dashboard from './dashboard/Dashboard';
import '../../stylesheets/stylesLayout/private.scss';
import AriPage from '../formsProperty/Ari/AriPage';
import TermsAndConditionsPopUp from '../../termsAndConditions/TermsAndConditionsPopUp';
import routes from '../../utils/commonVariables/routes';
import OwnerPortalContainer from '../../layout/ownerPortalContainer/OwnerPortalContainer';
import AccountContainer from '../../accountSection/AccountContainer';
import Bookings from './yourBookings/Bookings';
import { ProviderZinantisMembers } from '../contextsProperty/ContextZinantisMembers';
import { useHotelOwner } from '../../contexts/HotelOwnerContext';
import Members from './zinantis/members/Members';
import ChannelManagers from './zinantis/channelManagers/ChannelManagers';
import { ProviderChannelManagers } from '../contextsProperty/ContextChannelManagers';
import ZinantisRequests from './zinantis/requests/ZinantisRequests';
import { ProviderTaxes } from '../contextsProperty/ContextTaxes';
import Supplements from './supplements/Supplements';
import { ProviderSupplements } from '../contextsProperty/ContextSupplements';
import TaxesListView from './taxes/TaxesListView';
import {
    AppSections,
    AppSectionsCore,
    AppSectionsZinantis,
} from '../../types/appConfiguration/appConfigTypes';
import StopSales from './stopSales/StopSales';
import { ProviderStopSales } from '../contextsProperty/ContextStopSales';
import StaticRatesContainer from './staticRatesContracts/StaticRatesContractContainer';

function OwnerPortalContainerMain({ match }) {
    const { ownerData } = useHotelOwner();
    return (
        <>
            <Switch>
                <ProtectedRoute
                    path={`${match.path}/your-properties`}
                    render={() => (
                        <OwnerPortalContainer>
                            <YourProperties />
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.PROPERTIES}
                />
                <ProtectedRoute
                    path={`${match.path}/your-bookings`}
                    render={props => (
                        <OwnerPortalContainer>
                            <Bookings {...props} />
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.BOOKINGS}
                />
                <ProtectedRoute
                    path={`${match.path}${routes.taxes}`}
                    render={() => (
                        <OwnerPortalContainer>
                            <ProviderTaxes>
                                <TaxesListView />
                            </ProviderTaxes>
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.TAXES}
                />
                <ProtectedRoute
                    path={`${match.path}${routes.supplements}`}
                    render={() => (
                        <OwnerPortalContainer>
                            <ProviderSupplements>
                                <Supplements />
                            </ProviderSupplements>
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.SUPPLEMENTS}
                />
                <ProtectedRoute
                    path={`${match.path}${routes.stopSales}`}
                    render={() => (
                        <OwnerPortalContainer>
                            <ProviderStopSales>
                                <StopSales />
                            </ProviderStopSales>
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.STOP_SALES}
                />
                <ProtectedRoute
                    path={`${match.path}${routes.contracts}`}
                    render={props => (
                        <OwnerPortalContainer>
                            <StaticRatesContainer {...props} />
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.CONTRACTS}
                />
                <ProtectedRoute
                    exact
                    path={`${match.path}/ari`}
                    render={() => (
                        <OwnerPortalContainer>
                            <AriPage />
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.ARI}
                />
                <ProtectedRoute
                    path={match.path + routes.accountSection}
                    render={routerProps => (
                        <AccountContainer {...routerProps} />
                    )}
                    alwaysVisible
                />
                <ProtectedRoute
                    path={
                        match.path +
                        routes.zinantisSection +
                        routes.zinantisMembers
                    }
                    render={() => (
                        <OwnerPortalContainer>
                            <ProviderZinantisMembers>
                                <Members />
                            </ProviderZinantisMembers>
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.ZINANTIS}
                    page={AppSectionsZinantis.MEMBERS}
                />
                <ProtectedRoute
                    path={
                        match.path +
                        routes.zinantisSection +
                        routes.zinantisChannelManagers
                    }
                    render={() => (
                        <OwnerPortalContainer>
                            <ProviderChannelManagers>
                                <ChannelManagers />
                            </ProviderChannelManagers>
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.ZINANTIS}
                    page={AppSectionsZinantis.CHANNEL_MANAGERS}
                />
                <ProtectedRoute
                    path={
                        match.path +
                        routes.zinantisSection +
                        routes.zinantisConnectionRequests
                    }
                    render={() => (
                        <OwnerPortalContainer>
                            <ProviderZinantisMembers>
                                <ZinantisRequests />
                            </ProviderZinantisMembers>
                        </OwnerPortalContainer>
                    )}
                    section={AppSections.ZINANTIS}
                    page={AppSectionsZinantis.CONNECTION_REQUESTS}
                />
                <ProtectedRoute
                    exact
                    path={`${match.path}`}
                    render={() => (
                        <OwnerPortalContainer>
                            <Dashboard />
                        </OwnerPortalContainer>
                    )}
                    alwaysVisible
                />
            </Switch>
            {ownerData && !ownerData.signed ? (
                <TermsAndConditionsPopUp />
            ) : null}
        </>
    );
}

export default OwnerPortalContainerMain;
